export default "__VITE_PUBLIC_ASSET__bd9864e7__"